import axios from "axios";


const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const uploadVideo = async (videoData) => {
  try {
    const response = await axios.post(`${BACKEND}/uploadVedio`, videoData);
    return response.data; 
  } catch (error) {
    console.error("Error uploading video:", error);
    throw error;
  }
};

export const fetchVideos = async () => {
    try {
      const response = await axios.get(`${BACKEND}/getVideos`);
      return response.data;
    } catch (error) {
      console.error("Error fetching videos:", error);
      throw error;
    }
  };

  export const deleteVideo = async (videoId) => {
    try {
      const response = await fetch(`${BACKEND}/videos/${videoId}`, {
        method: "DELETE",
      });
  
      if (!response.ok) {
        throw new Error("Failed to delete video");
      }
  
      return await response.json();
    } catch (error) {
      throw error;
    }
  };

  export const updateVideo = async (videoId, videoData) => {
    try {
      const response = await axios.put(`${BACKEND}/updateVedio/${videoId}`, videoData);
      return response.data;
    } catch (error) {
      console.error("Error updating video:", error);
      throw error;
    }
  };